import React, { useState, useEffect } from 'react';
import { useAuth, api } from '../App';

const PLATFORMS = [
  { id: 'facebook',  label: 'Facebook',  desc: 'Facebook-Seite',    color: '#1877f2', short: 'FB' },
  { id: 'instagram', label: 'Instagram', desc: 'Instagram Business', color: '#e1306c', short: 'IG' },
  { id: 'linkedin',  label: 'LinkedIn',  desc: 'LinkedIn-Seite',     color: '#0077b5', short: 'LI' },
  { id: 'gbp',       label: 'Google',    desc: 'Google Business',    color: '#ea4335', short: 'G'  },
];

export default function Channels() {
  const { token } = useAuth();
  const [channels, setChannels] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [adding,   setAdding]   = useState(false);
  const [form,     setForm]     = useState({ platform: 'facebook', label: '' });

  useEffect(() => {
    api('/channels', {}, token).then(setChannels).catch(console.error).finally(() => setLoading(false));
  }, [token]);

  async function handleAdd() {
    try {
      const data = await api('/channels', { method: 'POST', body: JSON.stringify(form) }, token);
      setChannels(p => [...p, data]); setAdding(false); setForm({ platform: 'facebook', label: '' });
    } catch {}
  }

  async function handleDelete(id) {
    try {
      await api(`/channels/${id}`, { method: 'DELETE' }, token);
      setChannels(p => p.filter(c => c.id !== id));
    } catch {}
  }

  return (
    <div style={{ padding: '36px', maxWidth: 760 }}>

      <div className="fade-up" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 28 }}>
        <div>
          <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 6 }}>
            <span className="gradient-text">Kanäle</span>
          </h1>
          <p style={{ color: 'var(--muted)', fontSize: 14 }}>
            Verwalte deine Social-Media-Kanäle.
          </p>
        </div>
        <button onClick={() => setAdding(!adding)} style={{
          background: adding ? 'var(--surface2)' : 'linear-gradient(135deg, var(--accent), #ff9900)',
          color: adding ? 'var(--muted2)' : '#fff',
          fontFamily: 'Syne', fontWeight: 700, fontSize: 13,
          padding: '10px 20px', borderRadius: 9, marginTop: 4,
          border: adding ? '1px solid var(--border)' : 'none',
          boxShadow: !adding ? '0 4px 16px rgba(255,107,0,0.25)' : 'none',
          transition: 'all 0.15s'
        }}>
          {adding ? '✕ Abbrechen' : '+ Kanal hinzufügen'}
        </button>
      </div>

      {/* Copy/Paste Hinweis */}
      <div className="fade-up" style={{
        display: 'flex', gap: 14, alignItems: 'flex-start',
        background: 'var(--teal-dim)', border: '1px solid rgba(0,229,176,0.15)',
        borderRadius: 'var(--radius)', padding: '14px 18px', marginBottom: 24,
        animationDelay: '0.05s'
      }}>
        <span style={{ fontSize: 16, marginTop: 1, flexShrink: 0 }}>ℹ</span>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--teal)', marginBottom: 3 }}>
            Copy/Paste Workflow aktiv
          </div>
          <div style={{ fontSize: 12, color: 'var(--muted2)', lineHeight: 1.55 }}>
            Posts werden generiert und können kopiert werden. Direktes Posten via Meta API wird nach der Genehmigung freigeschaltet.
          </div>
        </div>
      </div>

      {/* Formular */}
      {adding && (
        <div className="fade-up" style={{
          background: 'var(--surface)', border: '1px solid rgba(255,107,0,0.2)',
          borderRadius: 'var(--radius-lg)', padding: 24, marginBottom: 20
        }}>
          <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 18 }}>Neuer Kanal</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--muted)', letterSpacing: '0.05em' }}>PLATTFORM</span>
              <select value={form.platform} onChange={e => setForm(f => ({ ...f, platform: e.target.value }))}
                style={{
                  background: 'var(--surface2)', border: '1px solid var(--border)',
                  borderRadius: 9, padding: '11px 14px', color: 'var(--text)', fontSize: 14, outline: 'none'
                }}
              >
                {PLATFORMS.map(p => <option key={p.id} value={p.id}>{p.label} — {p.desc}</option>)}
              </select>
            </label>
            <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--muted)', letterSpacing: '0.05em' }}>NAME / LABEL</span>
              <input value={form.label} onChange={e => setForm(f => ({ ...f, label: e.target.value }))}
                placeholder="z.B. look4more Facebook"
                style={{
                  background: 'var(--surface2)', border: '1px solid var(--border)',
                  borderRadius: 9, padding: '11px 14px', color: 'var(--text)', fontSize: 14, outline: 'none'
                }}
                onFocus={e => e.target.style.borderColor = 'rgba(255,107,0,0.4)'}
                onBlur={e => e.target.style.borderColor = 'var(--border)'}
              />
            </label>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={handleAdd} style={{
                background: 'linear-gradient(135deg, var(--accent), #ff9900)',
                color: '#fff', fontFamily: 'Syne', fontWeight: 700, fontSize: 13,
                padding: '10px 24px', borderRadius: 9
              }}>Speichern</button>
            </div>
          </div>
        </div>
      )}

      {/* Kanäle */}
      {loading ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {[1,2].map(i => <div key={i} className="shimmer" style={{ height: 70, borderRadius: 'var(--radius)' }} />)}
        </div>
      ) : channels.length === 0 ? (
        <div style={{
          background: 'var(--surface)', border: '1px dashed var(--border2)',
          borderRadius: 'var(--radius-lg)', padding: 40, textAlign: 'center'
        }}>
          <div style={{ fontSize: 28, marginBottom: 12, opacity: 0.4 }}>⊹</div>
          <p style={{ color: 'var(--muted)', fontSize: 14 }}>Noch keine Kanäle hinzugefügt.</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {channels.map(ch => {
            const p = PLATFORMS.find(x => x.id === ch.platform) || { label: ch.platform, color: '#888', short: '?', desc: '' };
            return (
              <div key={ch.id} style={{
                background: 'var(--surface)', border: '1px solid var(--border)',
                borderRadius: 'var(--radius)', padding: '16px 20px',
                display: 'flex', alignItems: 'center', gap: 14,
                transition: 'border-color 0.15s'
              }}
              onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--border2)'}
              onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border)'}
              >
                <span style={{
                  width: 36, height: 36, borderRadius: 9, fontSize: 11, fontWeight: 800,
                  background: p.color + '18', color: p.color, flexShrink: 0,
                  display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>{p.short}</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 500, fontSize: 14 }} className="truncate">{ch.label}</div>
                  <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>{p.label} · {p.desc}</div>
                </div>
                <button onClick={() => handleDelete(ch.id)} style={{
                  fontSize: 12, color: 'var(--muted)', background: 'none',
                  padding: '5px 12px', border: '1px solid var(--border)', borderRadius: 8,
                  transition: 'all 0.15s'
                }}
                onMouseEnter={e => { e.currentTarget.style.color = 'var(--danger)'; e.currentTarget.style.borderColor = 'rgba(255,77,77,0.3)'; }}
                onMouseLeave={e => { e.currentTarget.style.color = 'var(--muted)'; e.currentTarget.style.borderColor = 'var(--border)'; }}
                >
                  Entfernen
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
